import React, { useEffect } from 'react';
import './css/Founders.css'; // Dedicated page styles

// Reusing your standalone, modular layout components
import Navbar from './components/Navbar';
import DownloadApp from './components/DownloadApp';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

// Import your custom images & icons
import aboutHeroBg from '../images/banner-founder-desk.jpg';
import { FaQuoteLeft } from 'react-icons/fa';

// Import placeholder images for team members (replace with actual team image imports)
import anandaImg from '../images/Ananda-Khamaru.jpg';

function Founders() {
    // Automatically scroll to top when visiting the Founders page
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="about-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="about-hero-section"
                style={{ backgroundImage: `url(${aboutHeroBg})` }}
            >
                <Navbar />
            </section>


            {/* 4. Founder's Quote / Message Section */}
            <section className="py-5 bg-white">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="p-5 text-center position-relative quote-box-wrapper">

                                {/* Founder Image */}
                                <div className="mb-4">
                                    <img
                                        src={anandaImg}
                                        alt="Dr. Ananda Khamaru"
                                        className="img-fluid rounded-circle"
                                        style={{
                                            width: "240px",
                                            height: "240px",
                                            objectFit: "cover",
                                            border: "6px solid #57BDB9",
                                        }}
                                    />
                                </div>

                                <FaQuoteLeft
                                    className="mb-3"
                                    style={{
                                        fontSize: "40px",
                                        color: "#57BDB9",
                                        opacity: 0.6,
                                    }}
                                />

                                <h3
                                    className="mb-2"
                                    style={{
                                        color: "#207AB4",
                                        fontWeight: "800",
                                        fontSize: "24px",
                                    }}
                                >
                                    A Message From The Founder
                                </h3>

                                <h5
                                    className="mb-4"
                                    style={{
                                        color: "#57BDB9",
                                        fontWeight: "700",
                                    }}
                                >
                                    Dr. Ananda Khamaru
                                </h5>

                                <p className="lead px-md-4 quote-text">
                                    <strong>
                                        Managing Director, Chief Executive Officer & Co-Founder
                                    </strong>
                                    <br />
                                    <br />

                                    Dr. Ananda Khamaru is the Managing Director, Chief Executive
                                    Officer and Co-Founder of Fixovera Pvt. Ltd., where he is
                                    responsible for shaping the company's vision of revolutionising
                                    service delivery and digital commerce through advanced
                                    AI-driven solutions. He possesses more than 10 years of
                                    experience in the design and implementation of enterprise-grade
                                    software systems and has built his career on turning complex
                                    technological challenges into scalable business solutions.
                                    <br />
                                    <br />

                                    Before establishing Fixovera, Dr. Khamaru founded Sky Limit
                                    Technology Solution in 2014, a pioneering technology company
                                    known for its innovative software solutions. During his tenure
                                    as a technical and strategic leader, he developed the concept
                                    and led the development of the Sky Banking Software, while
                                    managing various cross-functional teams across major projects.
                                    This experience strengthened his understanding of market
                                    requirements and his ability to transform innovative visions
                                    into practical, scalable products.
                                    <br />
                                    <br />

                                    Dr. Khamaru holds an M.Sc. in Computer Technology and a PhD in
                                    Big Data Analytics based on Machine Learning Methods. His
                                    technical expertise includes Oracle PL/SQL, Java, and Python
                                    programming, along with advanced knowledge of Machine Learning
                                    and Big Data Analytics. This broad technical foundation enables
                                    him to lead Fixovera in developing intelligent solutions that
                                    are both technologically advanced and responsive to evolving
                                    market needs.
                                    <br />
                                    <br />

                                    At Fixovera, Dr. Khamaru is passionate about creating an
                                    AI-powered marketplace that connects people with reliable
                                    household services while providing a digital platform for both
                                    businesses and consumers. Beyond business objectives, he is
                                    equally committed to developing technology that contributes to
                                    a more sustainable future.
                                    <br />
                                    <br />

                                    Under his leadership, Fixovera focuses on using research,
                                    technology, and data-driven solutions to address real-world
                                    challenges while reducing environmental impact. Every product
                                    developed reflects the company's commitment to meaningful
                                    innovation that improves people's lives while helping protect
                                    the planet.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* Download App Section */}
            <DownloadApp />

            {/* 5. Reusable Global Bottom Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default Founders;